import { Button } from "@/components/ui/button";
import logo from "@/assets/arabian-alwaha-logo.jpg";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/translations";
import { Link } from "react-router-dom";

const Header = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary-darker/95 backdrop-blur-sm border-b border-accent/20 shadow-soft">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-4 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="relative w-16 h-16 rounded-lg overflow-visible shadow-soft bg-white p-1 border-2 border-accent/20">
              <img
                src={logo}
                alt="Arabian Al Waha Est Logo"
                className="w-full h-full object-contain rounded-md"
                loading="eager"
                {...{ fetchpriority: "high" } as any}
                width="640"
                height="640"
                style={{ transform: 'translate3d(0, 0, 0)' }}
              />
              {/* ™ badge overlay */}
              <span
                aria-label="Trademark"
                title="Trademark"
                className="absolute -top-1.5 -right-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-accent text-primary-darker text-[9px] font-bold leading-none shadow ring-1 ring-primary-darker/30 select-none"
              >
                ™
              </span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-accent">
                Arabian Al Waha
                <sup
                  aria-label="Trademark"
                  title="Unregistered trademark — registration with SAIP pending"
                  className="ms-0.5 text-[0.55em] align-super font-semibold"
                >
                  ™
                </sup>
              </h1>
              <p className="text-xs text-primary-foreground/70 font-medium tracking-widest uppercase">Trading & Contracting</p>
            </div>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8 rtl:space-x-reverse">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-primary-foreground/90 hover:text-accent transition-smooth font-medium min-h-[44px] py-2 px-3"
              aria-label={language === 'ar' ? 'الانتقال إلى قسم عن الشركة' : 'Navigate to about section'}
            >
              {t.about}
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-primary-foreground/90 hover:text-accent transition-smooth font-medium min-h-[44px] py-2 px-3"
              aria-label={language === 'ar' ? 'الانتقال إلى قسم الخدمات' : 'Navigate to services section'}
            >
              {t.services}
            </button>
            <button 
              onClick={() => scrollToSection('industries')}
              className="text-primary-foreground/90 hover:text-accent transition-smooth font-medium min-h-[44px] py-2 px-3"
              aria-label={language === 'ar' ? 'الصناعات' : 'Navigate to industries section'}
            >
              {language === 'ar' ? 'الصناعات' : 'Industries'}
            </button>
            <button
              onClick={() => scrollToSection('contact-cta')}
              className="text-primary-foreground/90 hover:text-accent transition-smooth font-medium min-h-[44px] py-2 px-3"
              aria-label={language === 'ar' ? 'اتصل بنا' : 'Contact us'}
            >
              {language === 'ar' ? 'اتصل' : 'Contact'}
            </button>
            <Link
              to="/brochure"
              className="text-primary-foreground/90 hover:text-accent transition-smooth font-medium min-h-[44px] py-2 px-3 flex items-center"
              aria-label={language === 'ar' ? 'كتيب الشركة' : 'Company brochure'}
            >
              {language === 'ar' ? 'الكتيب' : 'Brochure'}
            </Link>
          </nav>

          {/* Language Switcher */}
          <div className="flex items-center">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;